var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2.99993H5.1C3.83988 2.99993 3.20982 2.99993 2.72852 3.24516C2.30516 3.46088 1.96095 3.80508 1.74524 4.22845C1.5 4.70975 1.5 5.33981 1.5 6.59993V12.8999C1.5 14.16 1.5 14.7901 1.74524 15.2714C1.96095 15.6948 2.30516 16.039 2.72852 16.2547C3.20982 16.4999 3.83988 16.4999 5.1 16.4999H11.4C12.6601 16.4999 13.2902 16.4999 13.7715 16.2547C14.1948 16.039 14.539 15.6948 14.7548 15.2714C15 14.7901 15 14.16 15 12.8999V9.74993M5.99998 11.9999H7.25589C7.62277 11.9999 7.80622 11.9999 7.97885 11.9585C8.1319 11.9217 8.27822 11.8611 8.41243 11.7789C8.5638 11.6861 8.69352 11.5564 8.95294 11.297L16.125 4.12493C16.7463 3.50361 16.7463 2.49625 16.125 1.87493C15.5037 1.25361 14.4963 1.25361 13.875 1.87492L6.70293 9.04698C6.4435 9.30641 6.31378 9.43612 6.22102 9.5875C6.13878 9.72171 6.07817 9.86802 6.04143 10.0211C5.99998 10.1937 5.99998 10.3772 5.99998 10.744V11.9999Z",
    stroke: "#0095FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b764dc8e4bd94e5aec2cebba2bda14d9.svg";
export { ForwardRef as ReactComponent };